import React from 'react';
import { PropagateLoader } from 'react-spinners';
import { colors } from '../style';
import { Typography, Box } from '@material-ui/core';

interface Props {
  className?: string;
  text?: string;
}

export const Loader: React.FC<Props> = (props) => {
  const { className, text } = props;
  return (
    <Box
      display='flex'
      justifyContent='center'
      alignItems='center'
      minHeight='250px'
      className={className || 'spinner-item'}
    >
      <PropagateLoader size={15} color={colors.secondary} />
      {text && <Typography variant='h2'>{text}</Typography>}
    </Box>
  );
};
